var _path, _path2, _rect, _path3, _path4, _path5, _path6, _rect2, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconVilla = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#2F1F19",
  strokeLinecap: "round",
  d: "M4.5 19.5h15"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#2F1F19",
  strokeLinecap: "square",
  strokeWidth: 1.5,
  d: "M4 10v11m16-11v11"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 5,
  height: 7,
  x: 13,
  y: 15,
  fill: "#2F1F19",
  rx: 1
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#2F1F19",
  strokeLinecap: "round",
  d: "M3 10V8.588a1 1 0 0 1 .514-.874L11.03 3.54a2 2 0 0 1 1.942 0l7.515 4.174a1 1 0 0 1 .514.874V10"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#2F1F19",
  strokeLinecap: "round",
  d: "m3 10 8.029-4.46a2 2 0 0 1 1.942 0L21 10"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#FEFEFE",
  d: "M14 16h3v5h-3z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  stroke: "#2F1F19",
  strokeLinecap: "round",
  strokeWidth: 1.5,
  d: "M2.75 21.25h18.5"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 5,
  height: 5,
  x: 6.5,
  y: 15.5,
  stroke: "#2F1F19",
  rx: 0.5,
  transform: "rotate(-90 6.5 15.5)"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  stroke: "#2F1F19",
  strokeLinecap: "round",
  d: "M7 13h4m-2 2v-2"
})));
export default SvgIconVilla;